import { BellaThunkAction } from '../types';
import { TRACKING_GTM } from './types';

// eslint-disable-next-line import/prefer-default-export
export const trackUniversalAnalyticsSessionInit: BellaThunkAction<void, string> = async dispatch => {
    dispatch({
        type: TRACKING_GTM,
        payload: {
            universalAnalyticsSessionInitDidFire: true,
        },
    });
};
